import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'ngx-formly-select',
    templateUrl: './formly-select.component.html',
    styleUrls: ['./formly-select.component.scss']
})
export class FormlySelectComponent extends FieldType {

    onRemove(event: any): void {
        this.field.templateOptions.remove(event);
    }

}
